"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalizationController = void 0;
const analytics_1 = require("@streem/analytics");
const api_1 = require("@streem/api");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const domain_id_1 = require("@streem/domain-id");
const toolbox_1 = require("@streem/toolbox");
const rxjs_1 = require("rxjs");
const logger_1 = require("../../util/logger");
const utils_1 = require("../wall/utils");
const last_created_at_1 = require("../../util/rx/last_created_at");
class PersonalizationController {
    constructor(config) {
        this.config = config;
        const localUserId = config.context.localUserId;
        if (!localUserId) {
            logger_1.logger.debug('Loaded PersonalizationController without a localUserId: personalizations will be disabled');
        }
        this.favorited = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('userFavorite'), (0, utils_1.accumulateAndMapWallEvents)('userFavorite'), (0, rxjs_1.map)(items => items.some(({ userSid }) => config.context.localUserId &&
            new domain_id_1.UserId(userSid).compare(config.context.localUserId))));
        this.roomOutcomeReport = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifact'), (0, utils_1.accumulateAndMapWallEvents)('artifact'), (0, utils_1.filterByProperty)('artifactType', streem_sdk_protobuf_1.WallItem.ArtifactType.ROOM_OUTCOME_REPORT), (0, last_created_at_1.lastCreatedAt)(), (0, rxjs_1.shareReplay)(1));
    }
    addRoomOutcomeReport(roomOutcomeReport) {
        const response = this.config.roomWall.addRoomOutcomeReport({
            artifactType: streem_sdk_protobuf_1.WallItem.ArtifactType.ROOM_OUTCOME_REPORT,
            roomOutcomeReport: roomOutcomeReport,
            status: streem_sdk_protobuf_1.WallItem.Artifact.Status.FULFILLED,
        });
        (0, analytics_1.recordArtifactFulfilled)(response);
        logger_1.logger.info(`added room outcome report to wall:`, response);
    }
    favoriteRoom() {
        (0, toolbox_1.invariant)(this.config.context.localUserId, 'Cannot favorite room without a localUserId');
        const id = this.config.roomWall.addFavorite(this.config.context.localUserId);
        logger_1.logger.info(`User favorited room: ${this.config.context.roomId} ${id}`);
        (0, analytics_1.recordCallLogFavoriteUpdated)(true);
    }
    unfavoriteRoom() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.localUserId, 'Cannot unfavorite room without a localUserId');
            try {
                const watcher = this.waitForFavoriteWallSync(false);
                yield api_1.StreemAPI.users.updateUserCallLogEntry(this.config.context.localUserId.toString(), this.config.context.roomId.toString(), { favorite: false });
                yield watcher;
                (0, analytics_1.recordCallLogFavoriteUpdated)(false);
            }
            catch (e) {
                logger_1.logger.error('Failed to unfavorite room:', this.config.context.roomId);
            }
        });
    }
    waitForFavoriteWallSync(expectedValue) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, rxjs_1.firstValueFrom)(this.favorited.pipe((0, rxjs_1.filter)(x => x === expectedValue), (0, rxjs_1.timeout)(10000)));
        });
    }
}
exports.PersonalizationController = PersonalizationController;
//# sourceMappingURL=personalization_controller.js.map